import { memo, useEffect, useState } from "react";
import "../../css/CollisionOverlay.css";
import { useMsg } from "../../services/Ros/Subscriber";

interface CollisionMessage {
  polygons: string[];
  detections: boolean[];
}

interface CollisionOverlayProps {
  direction?: string;
  stream: string;
}

const parseMessage = (message: CollisionMessage) => {
  return message;
};

const CollisionOverlayMemo: React.FC<CollisionOverlayProps> = ({
  stream,
}) => {
  const msg = useMsg();

  const [collisionMessages, setCollisionMessages] = useState<string[]>([]);
  const [positions, setPositions] = useState<string[]>([]);

  useEffect(() => {
    const parsedCollisionMessage = parseMessage(msg as CollisionMessage);
    const { polygons, detections } = parsedCollisionMessage;

    if (!polygons || !detections) {
      return;
    }

    const newCollisionMessages: string[] = [];
    const newPositions: string[] = [];

    for (let i = 0; i < Math.min(4, polygons.length); i++) {
      if (detections[i]) {
        const direction = polygons[i].replace("Polygon", "");

        newCollisionMessages.push(`Obstruction ${direction}`);

        let position = "top";

        if (
          stream === "front" ||
          stream === "ptz" ||
          stream === "thermal" ||
          stream === "gas" ||
          stream === "none"
        ) {
          if (direction === "Front") {
            position = "ctop";
          } else if (direction === "Left") {
            position = "cleft";
          } else if (direction === "Right") {
            position = "cright";
          } else {
            position = "cbottom";
          }
        } else if (stream === "rear") {
          if (direction === "Front") {
            position = "cbottom";
          } else if (direction === "Left") {
            position = "cright";
          } else if (direction === "Right") {
            position = "cleft";
          } else {
            position = "ctop";
          }
        }

        newPositions.push(position);
      }
    }

    // Update immediately when a message arrives
    setCollisionMessages(newCollisionMessages);
    setPositions(newPositions);

    // Clear the overlay if no new message arrives for 2 seconds
    const timeout = setTimeout(() => {
      setCollisionMessages([]);
      setPositions([]);
    }, 2000);

    // If another message arrives before 2 seconds,
    // cancel this timeout and start a new 2-second period.
    return () => {
      clearTimeout(timeout);
    };
  }, [msg, stream]);

  return (
    <>
      {collisionMessages.map((message, index) => (
        <div
          key={index}
          className={`collision-overlay ${positions[index]}`}
        >
          <p>{message}</p>
        </div>
      ))}
    </>
  );
};

export const CollisionOverlay = memo(CollisionOverlayMemo);